export const TRAINING_VIDEO_CODE_LIST = ['', '작업자', '밀폐공간'];

export function getVideoCodeText(code) {
  if (code === '작업자') return "작업자 안전교육";
  if (code === '밀폐공간') return "밀폐공간 안전교육";
  return "기본교육";
}

function safeBody(postContent) {
  try {
    const parsed = JSON.parse(postContent);
    return parsed && parsed.body ? parsed.body : {};
  } catch (e) {
    return {};
  }
}

function normalizeId(v) {
  if (v === '' || v === null || v === undefined) return v;
  const n = Number(v);
  return Number.isFinite(n) ? n : v;
}

/**
 * 필수 강의를 모두 합격했을 경우에만
 * 마지막 이수일 + 1년
 * (미충족 시 0)
 */
function calcExpireDateByYear(requiredIds, watchedPosts) {
  if (!requiredIds || requiredIds.length === 0) return 0;

  const requiredSet = new Set(requiredIds.map(normalizeId));
  const latestById = new Map(); // videoId -> timestamp

  for (let i = 0; i < watchedPosts.length; i++) {
    const post = watchedPosts[i];
    const body = safeBody(post.post_content);

    const videoPostId = normalizeId(body.videoPostId);
    if (!requiredSet.has(videoPostId)) continue;

    const ms = new Date(body.교육이수일).getTime();
    if (!Number.isFinite(ms)) continue;

    const prev = latestById.has(videoPostId)
      ? latestById.get(videoPostId)
      : 0;

    if (ms > prev) latestById.set(videoPostId, ms);
  }

  // 필수 강의 모두 충족 여부 확인
  for (const id of requiredSet.values()) {
    if (!latestById.has(id)) return 0;
  }

  // 가장 늦은 이수일
  let max = 0;
  for (const time of latestById.values()) {
    if (time > max) max = time;
  }

  return new Date(max).addYears(1).format("yyyy-MM-dd");
}

export async function applyEducationExpirationToUser(dispatch, options = {}) {
  const { projectId, userId } = options;

  // 이번년도 강의목록
  const trainingVideoListInfo = await dispatch("board/LOAD_POST_LIST", {
    projectId,
    boardId: 1064,
    page: 1,
    perPage: 30,
  });

  const 기본교육목록 = [];
  const 작업자교육목록 = [];
  const 밀폐공간교육목록 = [];

  const list = trainingVideoListInfo && trainingVideoListInfo.data
    ? trainingVideoListInfo.data
    : [];

  for (let i = 0; i < list.length; i++) {
    const video = list[i];
    const body = safeBody(video.post_content);
    const code = body.videoCode || '';
    const id = normalizeId(video.id);

    if (code === '밀폐공간') {
      밀폐공간교육목록.push(id);
    } else if (code === '작업자') {
      작업자교육목록.push(id);
    } else {
      기본교육목록.push(id);
    }
  }

  const trainingVideoIds = Array.from(new Set([
    ...기본교육목록,
    ...작업자교육목록,
    ...밀폐공간교육목록,
  ]));

  // 합격한 교육 이력만 조회
  const watchedTrainingVideos = await dispatch("board/LOAD_POST_LIST", {
    projectId,
    boardId: 1065,
    conditions: [
      { key: "user_id", operator: "=", value: userId },
      { key: "body.videoPostId", operator: "IN", value: trainingVideoIds },
      { key: "body.시험결과", operator: "=", value: "합격" },
    ],
  });

  const watchedPosts = watchedTrainingVideos && watchedTrainingVideos.data
    ? watchedTrainingVideos.data
    : [];

  return {
    기본교육만료일: calcExpireDateByYear(기본교육목록, watchedPosts),
    작업자교육만료일: calcExpireDateByYear(작업자교육목록, watchedPosts),
    밀폐공간교육만료일: calcExpireDateByYear(밀폐공간교육목록, watchedPosts),
  };
}
